import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyQueueState = ({ onUploadClick }) => {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="relative mb-8">
        {/* Background Circle */}
        <div className="w-32 h-32 bg-gradient-to-br from-primary/10 to-accent/10 rounded-full flex items-center justify-center">
          <div className="w-20 h-20 bg-gradient-to-br from-primary/20 to-accent/20 rounded-full flex items-center justify-center">
            <Icon name="FileText" size={32} color="var(--color-primary)" strokeWidth={1.5} />
          </div>
        </div>
        
        {/* Floating Icons */}
        <div className="absolute -top-2 -right-2 w-8 h-8 bg-success/20 rounded-full flex items-center justify-center animate-bounce">
          <Icon name="CheckCircle" size={16} color="var(--color-success)" strokeWidth={2} />
        </div>
        <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-accent/20 rounded-full flex items-center justify-center animate-pulse">
          <Icon name="Zap" size={16} color="var(--color-accent)" strokeWidth={2} />
        </div>
      </div>

      <h2 className="text-2xl font-bold text-foreground mb-3">
        Invoice Processing Queue is Empty
      </h2>
      
      <p className="text-muted-foreground max-w-md mb-8 leading-relaxed">
        Upload your invoices to start the AI-powered validation process. Our system will automatically validate VAT, CRN, and ensure ZATCA compliance.
      </p>

      <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4">
        <Button
          variant="default"
          size="lg"
          onClick={onUploadClick}
          iconName="Plus"
          iconPosition="left"
          className="w-full sm:w-auto"
        >
          Create New Batch
        </Button>
        
        <Button
          variant="outline"
          size="lg"
          onClick={() => window.location.href = '/batch-processing-overview'}
          iconName="Layers"
          iconPosition="left"
          className="w-full sm:w-auto"
        >
          View Batch Overview
        </Button>
      </div>

      {/* Feature Highlights */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12 max-w-4xl">
        <div className="text-center space-y-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto">
            <Icon name="Upload" size={20} color="var(--color-primary)" strokeWidth={2} />
          </div>
          <h3 className="font-semibold text-foreground">Batch Processing</h3>
          <p className="text-sm text-muted-foreground">
            Upload multiple PDF invoices at once for efficient batch processing
          </p>
        </div>
        
        <div className="text-center space-y-3">
          <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center mx-auto">
            <Icon name="Shield" size={20} color="var(--color-accent)" strokeWidth={2} />
          </div>
          <h3 className="font-semibold text-foreground">ZATCA Compliance</h3>
          <p className="text-sm text-muted-foreground">
            Automatic validation against Saudi Arabia tax authority requirements
          </p>
        </div>
        
        <div className="text-center space-y-3">
          <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center mx-auto">
            <Icon name="Clock" size={20} color="var(--color-success)" strokeWidth={2} />
          </div>
          <h3 className="font-semibold text-foreground">Real-time Processing</h3>
          <p className="text-sm text-muted-foreground">
            Monitor validation progress with live status updates
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyQueueState;

